import React, { useState, useEffect, useMemo,useRef } from "react";
import { useTable, useGlobalFilter } from 'react-table';
import axios from "axios";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import DynamicForm from '../common/DynamicForm';
import LoaderComponent from "../../../libraries/loader/loader";
import { Fetchexecutequery, Fetchheaderdata, Fetchupdatequery } from '../../../services/process/BRS1/brsService7';
import { CreateData } from '../../../services/process/process_data/process_data';
import { Icon,Grid } from 'semantic-ui-react';
import '../css/reconSummary.css';
import Select from "react-select";
import EditIcon from '@mui/icons-material/Edit';
import excelIcon from '../../../assets/images/excel.png';
import FilePreviewer from "../common/file_displayer";
import { Tabs, TabList, Tab, TabPanel } from "react-tabs";

function PurchaseRequirement() {
  const [formData, setFormData] = useState({});
  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
  const [filterconditions,setFilterconditions] =  useState([{"is_active" : 1,"entity_id" : userCredentials.selectedentity,"tenant_id": userCredentials.tenants_id,"group_id": userCredentials.groups_id}]);
  const [formData1, setFormData1] = useState([]);
  const [formData2, setFormData2] = useState([{}]);
  const [formData3, setFormData3] = useState([]);
  const [formData4, setFormData4] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [rowData, setRowData] = useState([]);
  const [tablerowData, settableRowData] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [fields, setFields] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [columnDefs, setColumnDefs] = useState([]);
  const [tablecolumnDefs, settableColumnDefs] = useState([]);
  const [fields1, setFields1] = useState(null);
  const [columnDefs1, setColumnDefs1] = useState([]);
  const [fields2, setFields2] = useState([]);
  const [columnDefs2, setColumnDefs2] = useState([]);
  const [fields3, setFields3] = useState(null);
  const [columnDefs3, setColumnDefs3] = useState([]);
  const [fields4, setFields4] = useState(null);
  const [columnDefs4, setColumnDefs4] = useState([]);
  const [prfno, setPrfno] = useState('');
  const [manager, setManager] = useState('');
  const [section2Rows, setSection2Rows] = useState([{}]);
  const [section3Rows, setSection3Rows] = useState([{}]);
  const [unMatchedHidden, setUnMatchedHidden] = useState(false);
  const [selectedFile, setSelectedFile] = useState('');

  const [createHidden, setCreateHidden] = useState(true);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editMode, setEditMode] = useState(false); // State to track if in edit mode
  const [quotations, setQuotations] = useState([{ id: 1, label: "Quotation 1" }]);
  const [selectedQuotationId, setSelectedQuotation] = useState(0);
  const [quotationData, setQuotationData] = useState([]);
  const [options, setOptions] = useState([]);
  const [quotationinputData, setQuotationinputData] = useState([]);
  const [selectedvalue, setSelectedvalue] = useState('');
  const [selectedRow, setSelectedRow] = useState(null);
  const baseUrl = "http://172.16.40.13:1201/static/";

  // State to control collapsibility of divs
  const [isDiv1Open, setIsDiv1Open] = useState(true);
  const [isDiv2Open, setIsDiv2Open] = useState(true);
  const [isDiv3Open, setIsDiv3Open] = useState(true);
  const [isDiv4Open, setIsDiv4Open] = useState(true);


  useEffect(() => {
    fetchFieldInfo(66, setFields, setColumnDefs);
    fetchFieldInfo(67, setFields2, setColumnDefs2);
    fetchFieldInfo(68, setFields3, setColumnDefs3);
    fetchFieldInfo(82, setFields4, setColumnDefs4);
    fetchprfTableInfo1();
    fetchtabledetailsInfo();
    console.log(userCredentials)
  }, []);

const handleSubmit = async (e) => {
  e.preventDefault(); // Prevent form default submission behavior

  try {
    if (editMode) {
      await handleUpdate(); // Await the update function if in edit mode
    } else {
      await handleCreate(); // Await the create function if not in edit mode
    }
  } catch (error) {
    console.error("Error in handleSubmit:", error);
    // Handle error appropriately, e.g., display a notification or message
  }
};

const handleUpdate = async () => {
  try {
    const formattedDate = getFormattedDate();
    const finyr = getFinancialYearTag(formData.invoice_date);

    // Step 2: Prepare main invoice data
    const updatedFormData = {
      ...formData,
      created_on: formattedDate,
      modified_on: formattedDate,
      entity_id: userCredentials.selectedentity,financial_year: finyr,is_purchase_approved : 1,
      modified_by: userCredentials.user_id,invoice_user_mail_id :userCredentials.user_email
    };
    const FileUploadCredentials_1 = Fetchupdatequery();
    if (updatedFormData.purchase_order_date) {
      const [day, month, year] = updatedFormData.purchase_order_date.split("-");
      updatedFormData.purchase_order_date = new Date(`${year}-${month}-${day}`).toISOString().slice(0, 19).replace("T", " ");
    }
    if (formData.invoice_date) {
      const [year, month,day ] = formData.invoice_date.split("-");
      updatedFormData.invoice_date = new Date(`${year}-${month}-${day}`).toISOString().slice(0, 19).replace("T", " ");
    }

    console.log("updatedFormData for update",updatedFormData,updatedFormData.unique_number);
    const update_payload = {
      schema_name: 'payments',
      table: 'approved_invoices',
      set_column: updatedFormData,
      where: [{ unique_number: updatedFormData.unique_number }]
    };

    await axios.post(FileUploadCredentials_1[1], update_payload, FileUploadCredentials_1[0]);

    // Step 5: Insert line items
    if (formData2?.length > 0) {
      await Promise.all(formData2.map((row, index) => {
        const updatedformdata2 = {
          ...row,
          invoice_number: updatedFormData.invoice_number,
          purchase_order_number: updatedFormData.purchase_order_number,
          amount: updatedFormData.invoice_amount,
          modified_on: formattedDate,
          entity_id: userCredentials.selectedentity,
          line_cgst_amount: row.line_cgst_amount ?? 0.00,
          line_sgst_amount: row.line_sgst_amount ?? 0.00,
          line_igst_amount: row.line_igst_amount ?? 0.00,
          line_cgst_percent: row.line_cgst_percent ?? 0.00,
          line_sgst_percent: row.line_sgst_percent ?? 0.00,
          line_igst_percent: row.line_igst_percent ?? 0.00,
          modified_by: userCredentials.user_id,
          last_updated_by: userCredentials.user_name
        };

        const update_payload_1 = {
      schema_name: 'payments',
      table: 'approved_invoices_line',
      set_column: updatedformdata2,
      where: [{ id: row.id }]
    };


        return axios.post(FileUploadCredentials_1[1], update_payload_1, FileUploadCredentials_1[0]);
      }));
    }

    setEditMode(false);
   setUnMatchedHidden(false);
   setCreateHidden(true);
   setFormData1([]);
  setFormData2([{}]);
  setFormData3([]);
  setFormData4([]);
    fetchFieldInfo(66, setFields, setColumnDefs);
    fetchFieldInfo(67, setFields2, setColumnDefs2);
    fetchFieldInfo(68, setFields3, setColumnDefs3);
    fetchFieldInfo(82, setFields4, setColumnDefs4);
    setActiveTab(0)
    console.log("Invoice creation completed!");
  } catch (err) {
    console.error("Error in handle Update:", err);
    setError("Error updating invoice");
  }
};


const [gridApi, setGridApi] = useState(null);

const onGridReady = (params) => {
  setGridApi(params.api);
};


const getFileDataRequired = (responseData) => {
    const dataValues = responseData;
    const requiredFileData = {};

    for (const key in dataValues) {
      if (key.startsWith("file_") && key.endsWith("_type")) {
        const fileTypeValue = dataValues[key];
        const fileIndex = key.split("_")[1]; // Extract the index (e.g., '1' from 'file_1_type')
        if (fileTypeValue.length > 0) {
          const filePath = dataValues[`file_${fileIndex}_path`];
          requiredFileData[`file_${fileIndex}`] = {
            type: fileTypeValue,
            path: filePath,
          };
        }
      }
    }

    return requiredFileData;
  };


    // Helper function to format date
  const getFormattedDate = () => {
    const currentDate = new Date();
    return currentDate.toISOString().slice(0, 19).replace("T", " ");
  };

  const enhanceRowsWithCommonFields = (rows, commonFields) =>
    rows.map(row => ({ ...row, ...commonFields }));

  // Helper function to create payload
  const createPayload = (database, table, formData) => ({
    database,
    table,
    formData,
  });

  // Helper function for Axios requests
  const makeApiRequest = (url, payload, headers) => {
    return axios.post(url, payload, headers)
      .then(response => {
        console.log("API Response:", response);
      })
      .catch(error => {
        console.error("API Error:", error);
        throw new Error("Error with API call");
      });
  };


  const fetchFieldInfo = async (headerConfigId, setFieldsFunc, setColumnDefsFunc) => {
    const payload = { headerconfig_id: headerConfigId, "filterconditions": filterconditions };
  
    try {
      const FileUploadCredentials = Fetchheaderdata();
      const response = await axios.post(
        FileUploadCredentials[1], 
        payload, 
        FileUploadCredentials[0]
      );
  
      const data = response.data;
      console.log("fetched data",data)

      if (data.fields?.length) {
        const columns = data.fields.map((field) => ({
          headerName: formatColumnName(field.columnName),
          field: field.columnName,
        }));
  
        setColumnDefsFunc(columns);
        setFieldsFunc(data.fields);
        console.log("updation completed")
        return { fields: data.fields };
      }
    } catch (error) {
      console.error(`Error fetching field info for headerConfigId ${headerConfigId}:`, error);
      setError("Error fetching fields data");
        return { fields: []};
    }
  };
    

  const formatColumnName = (name) =>
    name.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());

  

const fetchprfTableInfo1 = async () => {
  const payload = { headerconfig_id: 24, "filterconditions": filterconditions };

  try {
    const FileUploadCredentials = Fetchheaderdata(); // Function to fetch header data
    const response = await axios.post(
      FileUploadCredentials[1], // URL
      payload,                  // Payload
      FileUploadCredentials[0]  // Headers or Credentials
    );

    const data = response.data;
    if (data.fields && data.fields.length > 0) {
      // Map the fields to columns
      const columns = data.fields.map((field) => ({
        headerName: formatColumnName(field.columnName),
        field: field.columnName,
        sortable: true,
        filter: true,
        resizable: true,
        width: 150,
      }));

      // Define the "Select" column
      const selectColumn = {
        headerName: "",
        checkboxSelection: true,
        width: 50,
        pinned: "left", // Optional: pin the column to the left for better visibility
      };

      // Add the "Select" column as the first column
      columns.unshift(selectColumn);

      console.log("Table Column Definitions:", columns);
      settableColumnDefs(columns); // Update state with column definitions
    }
  } catch (error) {
    console.error("Error fetching field info:", error);
    setError("Error fetching fields data");
  } finally {
    setLoading(false); // Ensure loading state is updated even in case of an error
  }
};


const fetchprfTableInfo2 = async () => {
  const payload = { headerconfig_id: 74, "filterconditions": filterconditions };

  try {
    const FileUploadCredentials = Fetchheaderdata(); // Function to fetch header data
    const response = await axios.post(
      FileUploadCredentials[1], // URL
      payload,                  // Payload
      FileUploadCredentials[0]  // Headers or Credentials
    );

    const data = response.data;
    if (data.fields && data.fields.length > 0) {
      // Map the fields to columns
      const columns = data.fields.map((field) => ({
        headerName: formatColumnName(field.columnName),
        field: field.columnName,
        sortable: true,
        filter: true,
        resizable: true,
        width: 150,
      }));

      // Define the "Select" column
      const selectColumn = {
        headerName: "",
        checkboxSelection: true,
        width: 50,
        pinned: "left", // Optional: pin the column to the left for better visibility
      };


      // Add the "Select" column as the first column
      columns.unshift(selectColumn);

      console.log("Table Column Definitions:", columns);
      settableColumnDefs(columns); // Update state with column definitions
    }
  } catch (error) {
    console.error("Error fetching field info:", error);
    setError("Error fetching fields data");
  } finally {
    setLoading(true); // Ensure loading state is updated even in case of an error
  }
};


  const onFilterTextChange = (event) => {
    const { value } = event.target;
    setSearchText(value);
  };

  const navigate = (direction) => {
    if (direction === 'next' && currentIndex < options.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else if (direction === 'prev' && currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

const addRow2 = () => {
  setFormData2((prev) => [...prev, {}]);
};


const deleteRow2 = (index) => {
  setFormData2((prev) => {
    if (prev.length === 1) return prev; // prevent deleting last row
    return prev.filter((_, i) => i !== index);
  });
};



  const getFileType = (filePath) => {
    const extension = filePath.split('.').pop().toLowerCase(); // Get the file extension
    if (extension === 'pdf') {
      return 'pdf';
    } else if (['jpg', 'jpeg', 'png', 'gif'].includes(extension)) {
      return 'image';
    }
    return 'unsupported';
  };


  const [currentIndex, setCurrentIndex] = useState(0);
  const currentFile = options[currentIndex];
  const fileType =  currentFile ? getFileType(currentFile.path) : null;

const handleClick = () => {
  if (!selectedRow || selectedRow.length === 0) {
    alert("Please select a row before clicking.");
    return; // stop further execution
  }

  // Proceed if a row is selected
  BrsTypeList();
  setCurrentIndex(0);
  if (activeTab === 0) {
fetchinvformdetails();
} else {
fetcheditinvformdetails();
}

  setUnMatchedHidden(true);
  setCreateHidden(false);
};

  const handleClick1 = () => {
   setFormData1([]);
  setFormData2([{}]);
  setFormData3([]);
  setFormData4([]);
    fetchFieldInfo(66, setFields, setColumnDefs);
    fetchFieldInfo(67, setFields2, setColumnDefs2);
    fetchFieldInfo(68, setFields3, setColumnDefs3);
    fetchFieldInfo(82, setFields4, setColumnDefs4);
gridApi.deselectAll();
  if (activeTab === 0) {
fetchprfTableInfo1();
    fetchtabledetailsInfo();
} else {
fetchprfTableInfo2();
fetchedittabledetailsInfo();
}


   setUnMatchedHidden(false);
   setCreateHidden(true);
  };


  const fetchtabledetailsInfo = async () => {
  const formatted = userCredentials.division.join(",");
  const formatted1 = userCredentials.department.join(",");
    setSearchText("");
setEditMode(false);
    const payload = { query: `SELECT id,purchase_order_type,IFNULL(TRIM(month), '') as month, IFNULL(TRIM(purchase_order_number), '') AS 'purchase_order_number', IFNULL(DATE_FORMAT(po_date, '%d-%m-%Y'), '') AS 'po_date',
			      IFNULL(TRIM(vendor_name), '') AS 'vendor_name', IFNULL(TRIM(po_purpose), '') AS 'po_purpose', IFNULL(TRIM(delivery_location), '') AS 'delivery_location', IFNULL(TRIM(po_kind), '') AS 'po_kind',
			      IFNULL(TRIM(expense_category), '') AS 'expense_category', IFNULL(TRIM(department_category), '') AS 'department_category', IFNULL(TRIM(sbu_head), '') AS 'sbu_head', IFNULL(TRIM(cost_code), '') AS 'Cost Center Code',
			      IFNULL(CONVERT(provision_cost, CHAR), '0.00') AS 'provision_cost', IFNULL(CONVERT(provision_amount, CHAR), '0.00') AS 'provision_amount', IFNULL(CONVERT(gst_amount, CHAR), '0.00') AS 'gst_amount', IFNULL(CONVERT(total_po_value, CHAR), '0.00') AS 'total_po_value',
	       		      IFNULL(TRIM(po_requestor), '') AS 'po_requestor', IFNULL(TRIM(po_type), '') AS 'PO Type', IFNULL(TRIM(prepared_by), '') AS 'prepared_by', IFNULL(TRIM(cross_checked_by), '') AS 'cross_checked_by', IFNULL(TRIM(po_status_approved_by), '') AS 'po_status_approved_by', IFNULL(TRIM(payment_terms), '') AS 'payment_terms',
			      IFNULL(TRIM(delivery_period), '') AS 'delivery_period', IFNULL(CONVERT(invoice_amount, CHAR), '0.00') AS 'invoice_amount', IFNULL(CONVERT(difference_amount, CHAR), '') AS 'difference_amount', IFNULL(TRIM(status), '') AS 'status', IFNULL(TRIM(ap_module_ibn), '') AS 'ap_module_ibn', IFNULL(TRIM(budgeted_or_not_budgeted), '') AS 'budgeted_or_not_budgeted',
			      adhoc_invoice_details_id, id, IFNULL(TRIM(vendor_code), '') AS 'vendor_code',IFNULL(TRIM(spoc_type), '') AS 'spoc_type' FROM payments.purchase_order_mapped WHERE is_mapped_file = 0 and 
purchase_order_type IN (
        SELECT name FROM user_management_uat.divisions 
        WHERE division_id IN (${formatted})
      ) AND entity_id = ${userCredentials.selectedentity} AND is_active = 1
and spoc_type IN (
        SELECT name FROM user_management_uat.department 
        WHERE department_id IN (${formatted1})
      );` };

    try {
      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      const data = response.data;
      if (data && data.length > 0) {
        const columns = Object.keys(data[0]).map((key) => ({
          headerName: formatColumnName(key),
          field: key,
        }));

        settableRowData(data);
      }
    } catch (error) {
      console.error("Error fetching department data:", error);
      setError("Error fetching department data");
    }
  };

const deleteAttachments1 = async () => {
  try {
 if (!selectedRow || selectedRow.length === 0) {
    alert("Please select a row before clicking.");
    return; // stop further execution
  }

    const confirmed = window.confirm(
      "Are you sure you want to delete this attachment?"
    );
    if (!confirmed) {
      return; // User clicked Cancel
    }
    const payload_invoice = {
      schema_name: "payments",
      table: "adhoc_invoice_details",
      set_column: [
        { purchase_order_number : null }
      ],
      where: [
        { id: selectedRow[0].adhoc_invoice_details_id }
      ]
    };
    const payload_invoice_1 = {
      schema_name: "payments",
      table: "purchase_order_mapped",
      set_column: [
        { is_active : 0 }
      ],
      where: [
        { id: selectedRow[0].id }
      ]
    };

    const FileUploadCredentials_3 = Fetchupdatequery();
    await axios.post(
      FileUploadCredentials_3[1],
      payload_invoice,
      FileUploadCredentials_3[0]
    );
    await axios.post(
      FileUploadCredentials_3[1],
      payload_invoice_1,
      FileUploadCredentials_3[0]
    );

    console.log("adhoc_invoice_details updated successfully");
fetchtabledetailsInfo();
    alert("Record Unmapped successfully.");
  } catch (error) {
    console.error("Failed to update adhoc_invoice_details", error);
    alert("Failed to unmap record. Please try again.");
  }

};



  const fetchinvformdetails = async () => {
    
    const payload = { query: `select vi.pan_number as vendor_pan_number,vi.gst_number as vendor_gst_number,vi.address as vendor_address,IFNULL(DATE_FORMAT(po.po_date, '%d-%m-%Y'), '') as purchase_order_date,po.purchase_order_number,po.delivery_location as place_of_supply,po.vendor_name,po.vendor_code from payments.purchase_order_mapped po
 left join po_process.vendor_master vi on vi.vendor_code = po.vendor_code where po.id = ${selectedRow[0].id};` };

    try {
      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      const data = response.data;

	console.log("Table Row Data:", data);

        // setFormData(data[0]);
if (Array.isArray(data) && data.length > 0) {
  setFormData(data[0]);
} else {
  setFormData({}); // or setFormData({}) depending on your default
}

    } catch (error) {
      console.error("Error fetching department data:", error);
      setError("Error fetching department data");
    }
  };
  const fetcheditinvformdetails = async () => {
    
    const payload = { query: `select *,IFNULL(DATE_FORMAT(invoice_date, '%Y-%m-%d'), '') AS 'invoice_date',IFNULL(DATE_FORMAT(purchase_order_date, '%d-%m-%Y'), '') AS 'purchase_order_date' from payments.approved_invoices where id = ${selectedRow[0].id};` };
    const payload_1 = { query: `select * from payments.approved_invoices_line where approved_invoice_id = ${selectedRow[0].id};` };

    try {
      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      const data = response.data;

      const response_1 = await axios.post(
        FileUploadCredentials[1],
        payload_1,
        FileUploadCredentials[0]
      );

      const data_1 = response_1.data;


if (Array.isArray(data) && data.length > 0) {
  setFormData(data[0]);
  setFormData3(data[0]);
  setFormData4(data[0]);

} else {
  setFormData([]); // or setFormData({}) depending on your default
  setFormData3([]);
  setFormData4([]);
}

console.log("data_1",data)

if (Array.isArray(data_1) && data_1.length > 0) {
  setFormData2(data_1);

} else {
  setFormData2([{}]); // or setFormData({}) depending on your default
}

    } catch (error) {
      console.error("Error fetching invoice data:", error);
      setError("Error fetching invoice data");
    }
  };

// Helper to convert DD-MM-YYYY to MySQL DATETIME
const convertToMySQLDateTime = (dateStr) => {
  if (!dateStr) return null;
  const [day, month, year] = dateStr.split('-');
  const date = new Date(`${year}-${month}-${day}T00:00:00`);
  // Format to YYYY-MM-DD HH:MM:SS
  const pad = (n) => n.toString().padStart(2, '0');
  const formatted = `${date.getFullYear()}-${pad(date.getMonth()+1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
  return formatted;
};

function getFinancialYearTag() {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth() + 1; // Jan=0, so +1

  let fyStart, fyEnd;
  if (month >= 4) {
    // April ? March cycle
    fyStart = year.toString().slice(-2);
    fyEnd = (year + 1).toString().slice(-2);
  } else {
    fyStart = (year - 1).toString().slice(-2);
    fyEnd = year.toString().slice(-2);
  }

  return `FI(${fyStart}-${fyEnd})`;
}


const handleCreate = async () => {
  try {
    const formattedDate = getFormattedDate();
    console.log("selectedRow",selectedRow)
  const formatted = userCredentials.department.join(",");
    const finyr = getFinancialYearTag();
    // Step 0: Fetch uniqueid, num, key
    const payloads = {
      query: `SELECT id, \`value\`, concat(expression, \`value\`) as uniqueid 
              FROM payments.payments_config 
              WHERE entity_id = ${userCredentials.selectedentity} 
                AND type in (
        SELECT name FROM user_management_uat.department 
        WHERE department_id IN (${formatted})
      ) 
;`
    };
    const FileUploadCredentials1 = Fetchexecutequery();
    const response1 = await axios.post(FileUploadCredentials1[1], payloads, FileUploadCredentials1[0]);
    const { uniqueid, value: num, id: key } = response1.data[0];

    // Step 1: Update payments_config
    const update_payload = {
      schema_name: 'payments',
      table: 'payments_config',
      set_column: { value: num + 1 },
      where: [{ id: key }]
    };
    const FileUploadCredentials_1 = Fetchupdatequery();
    await axios.post(FileUploadCredentials_1[1], update_payload, FileUploadCredentials_1[0]);

    // Step 2: Prepare main invoice data
    const updatedFormData = {
      ...formData,
      ...formData3,
      ...formData4,
      created_on: formattedDate,
      modified_on: formattedDate,
      entity_id: userCredentials.selectedentity,financial_year: finyr,
      created_by: userCredentials.user_id,is_purchase_approved : 1,
      modified_by: userCredentials.user_id,sbi_spoc_level : selectedRow[0].spoc_type,
      purchase_order_mapped_id: selectedRow[0].id,unique_number: uniqueid,invoice_type : selectedRow[0].purchase_order_type,invoice_user_mail_id :userCredentials.user_email
    };

    if (updatedFormData.purchase_order_date) {
      const [day, month, year] = updatedFormData.purchase_order_date.split("-");
      updatedFormData.purchase_order_date = new Date(`${year}-${month}-${day}`).toISOString().slice(0, 19).replace("T", " ");
    }

    // Step 3: Insert main invoice
    const payload = createPayload("payments", "approved_invoices", updatedFormData);
    const FileUploadCredentials = CreateData();
    await axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0]);

    // Step 4: Fetch newly created invoice id
    const payload_1 = {
      query: `SELECT id FROM payments.approved_invoices 
              WHERE invoice_number = '${updatedFormData.invoice_number}' 
                AND purchase_order_number = '${updatedFormData.purchase_order_number}' 
                AND created_on = '${formattedDate}'`
    };
    const response2 = await axios.post(FileUploadCredentials1[1], payload_1, FileUploadCredentials1[0]);
    const id = response2.data[0].id;

    // Step 5: Insert line items
    if (formData2?.length > 0) {
      await Promise.all(formData2.map((row, index) => {
        const updatedformdata2 = {
          ...row,
          invoice_number: updatedFormData.invoice_number,
          purchase_order_number: updatedFormData.purchase_order_number,
          amount: updatedFormData.invoice_amount,
          sequence: index + 1,
          created_on: formattedDate,
          modified_on: formattedDate,
          approved_invoice_id: id,
          entity_id: userCredentials.selectedentity,
          line_cgst_amount: row.line_cgst_amount ?? 0.00,
          line_sgst_amount: row.line_sgst_amount ?? 0.00,
          line_igst_amount: row.line_igst_amount ?? 0.00,
          line_cgst_percent: row.line_cgst_percent ?? 0.00,
          line_sgst_percent: row.line_sgst_percent ?? 0.00,
          line_igst_percent: row.line_igst_percent ?? 0.00,
          created_by: userCredentials.user_id,
          modified_by: userCredentials.user_id,
      last_updated_by: "SHABANA"
        };

        const payload_2 = createPayload("payments", "approved_invoices_line", updatedformdata2);
        const FileUploadCredentials2 = CreateData();
        return axios.post(FileUploadCredentials2[1], payload_2, FileUploadCredentials2[0]);
      }));
    }

    setEditMode(false);
    const update_payload_1 = {
      schema_name: 'payments',
      table: 'purchase_order_mapped',
      set_column: { is_mapped_file: 1 },
      where: [{ id: selectedRow[0].id}]
    };
    await axios.post(FileUploadCredentials_1[1], update_payload_1, FileUploadCredentials_1[0]);
   setUnMatchedHidden(false);
   setCreateHidden(true);
   setFormData1([]);
  setFormData2([{}]);
  setFormData3([]);
  setFormData4([]);
    fetchFieldInfo(66, setFields, setColumnDefs);
    fetchFieldInfo(67, setFields2, setColumnDefs2);
    fetchFieldInfo(68, setFields3, setColumnDefs3);
    fetchFieldInfo(82, setFields4, setColumnDefs4);
   fetchtabledetailsInfo();
    console.log("Invoice creation completed!");
  } catch (err) {
    console.error("Error in handleCreate:", err);
    setError("Error creating approved invoice");
  }
};

const handleDeleteClick = async () => {
  // Ask for confirmation
  const confirmDelete = window.confirm("Are you sure you want to delete?");
  if (!confirmDelete) return; // Stop if user cancels

  try {
    const update_payload_1 = {
      schema_name: "payments",
      table: "purchase_order_mapped",
      set_column: { is_active: 0 },
      where: [{ id: selectedRow[0].id }],
    };
    const FileUploadCredentials_1 = Fetchupdatequery();
    await axios.post(FileUploadCredentials_1[1], update_payload_1, FileUploadCredentials_1[0]);
    fetchtabledetailsInfo();
    alert("Deleted successfully ?");

  } catch (error) {
    console.error("Error deleting row:", error);
    alert("Failed to delete. Please try again ?");
  }
};



  function BrsTypeList() {
    console.log(selectedRow);
    let payload = {
      query : `SELECT IFNULL(TRIM(file_1_type), '') AS 'file_1_type', IFNULL(TRIM(file_1_path), '') AS 'file_1_path', IFNULL(TRIM(file_2_type), '') AS 'file_2_type', IFNULL(TRIM(file_2_path), '') AS 'file_2_path', IFNULL(TRIM(file_3_type), '') AS 'file_3_type', IFNULL(TRIM(file_3_path), '') AS 'file_3_path', IFNULL(TRIM(file_4_type), '') AS 'file_4_type', IFNULL(TRIM(file_4_path), '') AS 'file_4_path', IFNULL(TRIM(file_5_type), '') AS 'file_5_type', IFNULL(TRIM(file_5_path), '') AS 'file_5_path', IFNULL(TRIM(file_6_type), '') AS 'file_6_type', IFNULL(TRIM(file_6_path), '') AS 'file_6_path', IFNULL(TRIM(file_7_type), '') AS 'file_7_type', IFNULL(TRIM(file_7_path), '') AS 'file_7_path', IFNULL(TRIM(file_8_type), '') AS 'file_8_type', IFNULL(TRIM(file_8_path), '') AS 'file_8_path', IFNULL(TRIM(file_9_type), '') AS 'file_9_type', IFNULL(TRIM(file_9_path), '') AS 'file_9_path', IFNULL(TRIM(file_10_type), '') AS 'file_10_type', IFNULL(TRIM(file_10_path), '') AS 'file_10_path' FROM payments.adhoc_invoice_details WHERE id = ${selectedRow[0].adhoc_invoice_details_id};`
    }
    console.log('payload', payload);
    var getProcessingLayerList = Fetchexecutequery();
    console.log("brs", getProcessingLayerList)

    axios.post(getProcessingLayerList[1], payload, getProcessingLayerList[0])
      .then(
        response => {
          console.log("Processing customer List vendor code!!!", response)
          
          let properData = response["data"];
          const purchaseOrdersList = properData.map((data) =>
          getFileDataRequired(data)
        );
	console.log("purchaseOrdersList",purchaseOrdersList)
        // Extract file paths
        const files = [];
        purchaseOrdersList.forEach((fileData) => {
          for (const key in fileData) {
           const fileEntry = fileData[key];
        // Ensure fileEntry is an object and has a path property
        console.log("file paths",files,fileEntry)
        if (fileEntry && typeof fileEntry === "object" && "path" in fileEntry) {
            files.push({
              path: fileEntry.path
            });
          }
          }
        });
	console.log("options",files)
	const formattedOptions = files.map((file, index) => ({
	  label: file,       // The text displayed in the dropdown
	  key: index,       // A unique key for each option
	  value: `${file.path}`,      // The value that will be passed to onChange
	}));
	console.log("formattedOptions",formattedOptions)
        setOptions(files);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer List!!!", error);
        }
      );
  }


  const handleInputChange = (name, value) => {
    console.log("formdata",formData)
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

const handleInputChange12352 = (index, name, value) => {
  console.log(index, name, value);
  setFormData2((prev) => {
    const updated = [...prev];
    updated[index] = { ...updated[index], [name]: value };
    return updated;
  });
};
const handleInputChange2 = (index, name, value) => {
  console.log(index, name, value);
  setFormData2((prev) => {
    const updated = [...prev];
    let row = { ...updated[index] };

    const percentValue = Number(value) || 0;
    const quantity = Number(row.quantity) || 0;
    const rate = Number(row.rate_per_unit) || 0;
    let line_amount = Number(row.line_amount) || 0;

    // --- GST logic ---
    if (name === "line_sgst_percent") {
      row.line_sgst_percent = percentValue;
      row.line_cgst_percent = percentValue;
      row.line_igst_percent = 0;

      row.line_sgst_amount = (line_amount * percentValue) / 100;
      row.line_cgst_amount = (line_amount * percentValue) / 100;
      row.line_igst_amount = 0;
    } else if (name === "line_cgst_percent") {
      row.line_sgst_percent = percentValue;
      row.line_cgst_percent = percentValue;
      row.line_igst_percent = 0;

      row.line_sgst_amount = (line_amount * percentValue) / 100;
      row.line_cgst_amount = (line_amount * percentValue) / 100;
      row.line_igst_amount = 0;
    } else if (name === "line_igst_percent") {
      row.line_sgst_percent = 0;
      row.line_cgst_percent = 0;
      row.line_igst_percent = percentValue;

      row.line_sgst_amount = 0;
      row.line_cgst_amount = 0;
      row.line_igst_amount = (line_amount * percentValue) / 100;
    }

    // --- Amount logic (quantity * rate_per_unit) ---
    if (name === "quantity" || name === "rate_per_unit") {
      const newQuantity = name === "quantity" ? Number(value) || 0 : quantity;
      const newRate = name === "rate_per_unit" ? Number(value) || 0 : rate;
      row.quantity = newQuantity;
      row.rate_per_unit = newRate;

      row.line_amount = newQuantity * newRate;
      line_amount = row.line_amount; // update local amount for GST calculations

      // Recalculate GST amounts with updated amount
      if (row.line_sgst_percent || row.line_cgst_percent) {
        row.line_sgst_amount = (row.line_amount * row.line_sgst_percent) / 100;
        row.line_cgst_amount = (row.line_amount * row.line_cgst_percent) / 100;
      }
      if (row.line_igst_percent) {
        row.line_igst_amount = (row.line_amount * row.line_igst_percent) / 100;
      }
    } else if (
      name !== "line_sgst_percent" &&
      name !== "line_cgst_percent" &&
      name !== "line_igst_percent"
    ) {
      // Normal update
      row[name] = value;
    }

    // --- Calculate total line amount ---
row.amount = Number(
  (
    (Number(row.line_amount) || 0) +
    (Number(row.line_sgst_amount) || 0) +
    (Number(row.line_cgst_amount) || 0) +
    (Number(row.line_igst_amount) || 0)
  ).toFixed(2)
);

    updated[index] = row;

    // --- Calculate totals across all rows ---
    const totals = updated.reduce(
      (acc, r) => {
        acc.invoice_amount += Number(r.line_amount) || 0;
        acc.sgst_amount += Number(r.line_sgst_amount) || 0;
        acc.cgst_amount += Number(r.line_cgst_amount) || 0;
        acc.igst_amount += Number(r.line_igst_amount) || 0;
        acc.total_invoice_amount += Number(r.amount) || 0;
        return acc;
      },
      {
        invoice_amount: 0,
        sgst_amount: 0,
        cgst_amount: 0,
        igst_amount: 0,
        total_invoice_amount: 0,
      }
    );

    // --- Push totals to formData3 ---
    setFormData((prev3) => ({
      ...prev3,
      ...totals,
    }));

    return updated;
  });
};


  const handleInputChange3 = (name, value) => {
    console.log("formdata4",formData4)
    setFormData4((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };


  const validateField = (value, type) => {
      if (!type) return true; // If no type is defined, skip validation

      switch (type.value) {
          case "text":
              return true; // Allow any text input
          case "integer":
              return /^-?\d*$/.test(value); // Allow integers (positive or negative) and empty input for partial typing
          case "decimal":
              return /^-?\d*\.?\d*$/.test(value); // Allow numbers with optional decimal points
          case "date":
              return !isNaN(Date.parse(value)); // Validate as a valid date
          default:
              return true; // For unsupported types, skip validation
      }
  };


  const handleInputChange1 = (name, value, index,type) => {
    console.log("section2rows",section2Rows)
    setSection2Rows(prevRows => {
      const updatedRows = [...prevRows];
      const isValid = validateField(value, type);
      if (!isValid) {
        console.warn(`Invalid input for ${type?.label}: ${value}`);
        return prevRows; // If invalid, do not update the state
      }
      // Update the field with the new value
      updatedRows[index] = {
        ...updatedRows[index],
        [name]: value,
      };
      // If the updated field is 'quantity' or 'unit_value', recalculate 'total_value'
      if (name === "quantity" || name === "unit_value") {
        const updatedRow = updatedRows[index];
        const totalValue = updatedRow.quantity * updatedRow.unit_value;
        // Update the total_value in the row
        updatedRows[index] = {
          ...updatedRow,
          total_value: totalValue,  // Recalculate total_value
        };
      }
      // Return the updated rows after modifying the necessary fields
      return updatedRows;
    });
  };

  useEffect(() => {
  if (activeTab === 0) {
fetchprfTableInfo1();
    fetchtabledetailsInfo();
} else {
fetchprfTableInfo2();
fetchedittabledetailsInfo();
}
  }, [activeTab]);


 const fetchedittabledetailsInfo = async () => {
      setLoading(true);
  const formatted = userCredentials.division.join(",");
  console.log("activeTab",activeTab);

  let condition = "is_approver_approved = 0 AND is_approver_rejected = 0 AND is_approver_hold = 0 AND is_finance_approved = 0 AND is_finance_hold = 0 AND is_finance_rejected = 0 AND";

  if (activeTab === 1) {
    condition = "invoice_status in ('SENT TO APPROVER','SENT TO FINANCE') AND";
  } else if (activeTab === 2) {
    condition = "invoice_status in ('HOLD BY APPROVER','HOLD BY FINANCE') AND";
  } else if (activeTab === 4) {
    condition = "invoice_status in ('APPROVED BY APPROVER','APPROVED BY FINANCE')  AND";
  } else if (activeTab === 3) {
    condition = "invoice_status in ('REJECTED BY APPROVER','REJECTED BY FINANCE') AND";
  } else if (activeTab === 5) {
    condition = "invoice_status in ('PAID','PARTLY PAID') AND"; // For "All"
  }  else if (activeTab === 6) {
    condition = ""; // For "All"
  }

setEditMode(true);
  const formatted1 = userCredentials.department.join(",");

    const payload = { query: `SELECT 
  ai.invoice_status,
  IFNULL(TRIM(ai.vendor_name), '') AS vendor_name,
  IFNULL(TRIM(ai.vendor_code), '') AS vendor_code,
  IFNULL(TRIM(ai.vendor_address), '') AS vendor_address,
  IFNULL(TRIM(ai.place_of_supply), '') AS place_of_supply,
  IFNULL(TRIM(ai.invoice_number), '') AS invoice_number,
  IFNULL(DATE_FORMAT(ai.invoice_date, '%Y-%m-%d'), '') AS invoice_date,
  IFNULL(CONVERT(ai.total_invoice_amount, CHAR), '0.00') AS total_invoice_amount,
  IFNULL(TRIM(ai.purchase_order_number), '') AS purchase_order_number,
  IFNULL(DATE_FORMAT(ai.purchase_order_date, '%d-%m-%Y'), '') AS purchase_order_date,
  IFNULL(TRIM(ai.cost_center_code), '') AS cost_center_code,
  IFNULL(TRIM(ai.approver_mail_id), '') AS approver_mail_id,
  IFNULL(DATE_FORMAT(ai.approver_approval_date, '%d-%m-%Y'), '') AS approver_approval_date,
  IFNULL(TRIM(ai.expense_code), '') AS expense_code,
  IFNULL(TRIM(ai.expense_category), '') AS expense_category,
  IFNULL(TRIM(ai.invoice_type), '') AS invoice_type,
  IFNULL(TRIM(ai.invoice_user_mail_id), '') AS invoice_user_mail_id,
  IFNULL(TRIM(ai.invoice_extraction_type), '') AS invoice_extraction_type,
  IFNULL(TRIM(ai.sbi_cost_center_code), '') AS sbi_cost_center_code,
  IFNULL(TRIM(ai.sbi_site_code), '') AS sbi_site_code,
  IFNULL(TRIM(ai.site_name), '') AS sbi_site_name,
  ai.sbi_billable,  IFNULL(DATE_FORMAT(ai.created_on, '%d-%m-%Y'), '') AS created_on,
  IFNULL(TRIM(ai.unique_number), '') AS unique_number,
  IFNULL(TRIM(ai.revenue_invoice_number), '') AS revenue_invoice_number,
  ai.id,ai.finance_hold_comments,ai.finance_reject_comments,ai.approver_hold_comments,ai.approver_reject_comments,
  ai.purchase_order_mapped_id,
  IFNULL(TRIM(ai.month_of_service), '') AS month_of_service,
  IFNULL(TRIM(ai.approver_id), '') AS approver_id,ai.purchase_level_2_hold_comments,ai.purchase_level_2_reject_comments,
  pom.adhoc_invoice_details_id
FROM payments.approved_invoices ai
LEFT JOIN payments.purchase_order_mapped pom 
  ON ai.purchase_order_mapped_id = pom.id
WHERE ${condition}
  ai.invoice_type IN (
    SELECT name 
    FROM user_management_uat.divisions 
    WHERE division_id IN (${formatted})
  ) and spoc_type IN (
        SELECT name FROM user_management_uat.department 
        WHERE department_id IN (${formatted1})
      )
  AND ai.entity_id = ${userCredentials.selectedentity}
  AND ai.is_active = 1
ORDER BY ai.id DESC;
` };

    try {
      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      const data = response.data;
      if (data && data.length > 0) {
        const columns = Object.keys(data[0]).map((key) => ({
          headerName: formatColumnName(key),
          field: key,
        }));

        settableRowData(data);
    setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching department data:", error);
      setError("Error fetching department data");
        settableRowData(null);
    setLoading(false);
    }
  };



  const handlequotatationInputChange3 = (name, value, index,type) => {
    // First, update section3Rows
    console.log(section3Rows,index,quotationinputData)
    setSection3Rows(prevRows => {
      const updatedRows = [...prevRows];
      if (!Number.isInteger(index) || index < 0 || index >= updatedRows.length) {
        console.warn(`Invalid row index: ${index}. Defaulting to 0.`);
        index = 0; // Default index to 0 if invalid
      }

      const isValid = validateField(value, type);
      if (!isValid) {
        console.warn(`Invalid input for ${type?.label}: ${value}`);
        return prevRows; // If invalid, do not update the state
      }
      updatedRows[index] = {
        ...updatedRows[index],
        [name]: value,
      };
      // If the 'quantity' or 'unit_value' changed, recalculate total_value
      if (name === "quantity" || name === "unit_value") {
        const updatedRow = updatedRows[index];
        const totalValue = updatedRow.quantity * updatedRow.unit_value;
        // Update the total_value in the row
        updatedRows[index] = {
          ...updatedRow,
          total_value: totalValue,  // Recalculate total_value
        };
      }
      return updatedRows;
    });
    // Then, update quotationinputData
    setQuotationinputData(prevQuotationData => {
      const updatedQuotationData = [...prevQuotationData];

      // Initialize section3Rows for the selectedQuotationId if it doesn't exist
      if (!updatedQuotationData[selectedQuotationId]) {
        updatedQuotationData[selectedQuotationId] = [];
      }

      // Ensure the row exists in quotationData for the current index
      if (!updatedQuotationData[selectedQuotationId][index]) {
        updatedQuotationData[selectedQuotationId][index] = {};
      }


      // Update the specific field in quotationData
      updatedQuotationData[selectedQuotationId][index][name] = value;

      // If the 'quantity' or 'unit_value' changed, recalculate total_value
      if (name === "quantity" || name === "unit_value") {
        const updatedRow = updatedQuotationData[selectedQuotationId][index];
        const totalValue = updatedRow.quantity * updatedRow.unit_value;

        // Update the total_value in the row for quotationData
        updatedQuotationData[selectedQuotationId][index] = {
          ...updatedRow,
          total_value: totalValue,  // Recalculate total_value
        };
      }

      return updatedQuotationData;
    });
  };

  const onSelectionChanged = (event) => {
    const selectedRows = event.api.getSelectedRows();
    setSelectedRow(selectedRows); // Get the first selected row (single selection)

  };


  const handleQuotationChange = (name, value) => {
    setFormData2((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    // Update quotationData with the current quotation's edited data
    setQuotationData((prevData) => ({
      ...prevData,
      [selectedQuotationId]: {
        ...prevData[selectedQuotationId],
        [name]: value,
      },
    }));
    console.log("Updated field:",quotations, name, "with value:", value,quotationinputData);
  };

const gridRef = useRef();

const onBtnExportCSV = () => {
const tabLabel = tabConfig[activeTab]?.title || 'Invoices';
  gridRef.current.api.exportDataAsCsv({
    fileName: `User_${tabLabel}_invoices.csv`, // <-- Set your desired file name here
    columnKeys: tablecolumnDefs
      .filter(col => !col.checkboxSelection)
      .map(col => col.field),
    processCellCallback: (params) => params.value ?? '',
  });
};

  const tabConfig = [
    { title: "New", key: "New" },
    { title: "Sent for Approval", key: "sent_for_approval" },
    { title: "Hold", key: "Hold" },
    { title: "Rejected", key: "Rejected" },
    { title: "Approved", key: "Approved" },
    { title: "Paid Invoices", key: "Paid Invoices" },
    { title: "All", key: "All" },
  ];

  // Toggle div visibility
  const toggleDiv1 = () => setIsDiv1Open(!isDiv1Open);
  const toggleDiv2 = () => setIsDiv2Open(!isDiv2Open);
  const toggleDiv3 = () => setIsDiv3Open(!isDiv3Open);
  const toggleDiv4 = () => setIsDiv4Open(!isDiv4Open);



  return (
<>
<LoaderComponent loaderOpen={loading} />

<div>
    <div>
      <h2 className="pt-1 pb-1 text-center" style={{ color: "#0a2352", fontSize: '18px' }}>
        Invoice Details Entry
      </h2>
    </div>
    <div hidden={unMatchedHidden} style = {{paddingLeft: "10px",paddingRight: "10px",paddingTop: "10px"}}>
<Tabs selectedIndex={activeTab} onSelect={(index) => setActiveTab(index)}>
        {/* Tab headers */}
<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
  <TabList style={{ display: 'flex' }}>
    {tabConfig.map((tab, i) => (
      <Tab key={i} style={{ width: '150px', textAlign: 'center' }}>
        {tab.title}
      </Tab>
    ))}
  </TabList>
  <div style={{ display: "flex", alignItems: "center", gap: "15px",paddingRight:"5px" }}>
    <input
      className="search-input"
      type="text"
      placeholder="Search..."
      value={globalFilter}
      onChange={(e) => {
        setGlobalFilter(e.target.value);
        gridRef.current.api.setQuickFilter(e.target.value);
      }}
      style={{
        width: "280px",           // ? Wider search bar
        backgroundColor: "white",
        padding: "7px 12px",
        height: "34px",
        lineHeight: "34px",
        borderRadius: "6px",
        border: "1px solid #ccc",
        boxSizing: "border-box",
      }}
    />

    <img
      src={excelIcon}
      alt="Export to Excel"
      title="Download Excel"
      onClick={onBtnExportCSV}
      style={{
        width: "28px",
        height: "28px",
        cursor: "pointer",
      }}
    />
  </div>
</div>

        {/* Tab content */}
        {tabConfig.map((tab, i) => (
          <TabPanel key={i}>
                    <div
                      className="ag-theme-alpine"
                      style={{
                        overflowX: "auto",
                        overflowY: "auto",
                        borderRadius: "10px",
                        width: `${tablecolumnDefs.length * 150}px`,
                        maxWidth: "100%",
                        height: "543px",
                        paddingTop: "10px",
                      }}
                    >
                      <AgGridReact
                        onGridReady={onGridReady}
                        columnDefs={tablecolumnDefs}
                        rowData={tablerowData}
                        animateRows={true}
              		ref={gridRef}
                        pagination={true}
                        paginationPageSize={11}
                        rowSelection="single"
                        onSelectionChanged={onSelectionChanged}
              		enableCellTextSelection={true}
              		suppressCopyRows={true} 

                      />
                    </div>

                    {/* Action Buttons */}
                    <div className="submit-row">
                      <div>
                        <button className="submit-btn" onClick={handleClick}>
                          Extract Info
                        </button>
{activeTab === 0 && (
    <button
      className="submit-btn"
      onClick={deleteAttachments1}
    >
      Unmap
    </button>
  )}

                      </div>
                    </div>
          </TabPanel>
        ))}
      </Tabs>

	</div>
<div hidden={createHidden}>

  <div style={{  textAlign: 'center' }}>

    {/* Navigation Buttons */}

<div style={{ display: 'flex', gap: '10px' }}>
<div style = {{ width: "120%"}}>
    <div style={{ marginBottom: '10px' }}>
      <button
        onClick={() => navigate('prev')}
        disabled={currentIndex === 0}
        style={{ marginRight: '10px' }}
      >
        Previous
      </button>
      <button
        onClick={() => navigate('next')}
        disabled={currentIndex === options.length - 1}
      >
        Next
      </button>
    </div>

    {/* Guard Clause for currentFile */}
    {currentFile ? (
      <div style={{ textAlign: 'center',   marginLeft: '10px' }}>
        <h3>{currentFile.path.split('/').pop()}</h3> {/* Display file name */}

  {/* <div style={{ maxWidth: "790px", minWidth: "300px"  ,overflowX: "auto" }}> */}
<div
  style={{
    maxWidth: "790px",
    minWidth: "300px",
    height: "600px",
    overflowX: "auto", // scroll inside this div
    border: "1px solid #ccc",
  }}
>
  {currentFile && fileType === "pdf" && (
    <FilePreviewer
      fileType="pdf"
      fileUrl={`http://206.1.17.185:1200/api/v2/user_modules/serve-pdf/${currentFile.path.split('/').pop()}`}
      style={{ height: "100%", width: "100%" }} // make the PDF fit
    />
  )}
</div>
        {fileType === 'image' && (
          <img
            src={`${baseUrl}/${currentFile.path}`}
            alt="Preview"
            style={{ maxWidth: '100%', maxHeight: '500px' }}
          />
        )}
        {fileType === 'unsupported' && (
          <h4 style={{ color: 'red' }}>Unsupported file type</h4>
        )}
      </div>

    ) : (
      <h3>No files to preview</h3> // Fallback UI if no files are available
    )}
</div>

<div style = {{width:'50%'}}>
          <div>
            <DynamicForm fields={fields} formData={formData} onInputChange={handleInputChange} onSubmit={handleSubmit} />
          </div>
<div style = {{ marginLeft: "20px", borderRadius: "8px", backgroundColor:'white'}}>
{formData2.length > 0 ? (
  formData2.map((row, index) => (
    <div
      key={index}
      style={{
        backgroundColor: "white",
        borderRadius: "8px",
        padding: "10px", display:"flex", 
      }}
    >
      <div style={{ marginTop: "30px", textAlign: "center", display:"flex"  }}>
<div>
        <Icon
          name="trash"
          size="large"
          color="red"
          style={{ cursor: "pointer", marginRight: "15px" }}
          onClick={() => deleteRow2(index)}
        />
</div>
<div>
        {index === formData2.length - 1 && (
          <Icon
            name="plus"
            size="large"
            color="green"
            style={{ cursor: "pointer" }}
            onClick={addRow2}
          />
        )}
</div>
      </div>

      {/* Horizontal scroll container */}
      <div
        style={{
          maxWidth: "100%",
          overflowX: "auto", display:"flex" ,
          paddingBottom: "15px", // space between fields and scrollbar
        }}
      >

        <div
          style={{
            display: "flex",
            gap: "20px",
            flexWrap: "nowrap",
          }}
        >
          {fields2.map((field, fieldIndex) => {
            if (!field.function) return null;

            return (
              <div
                key={fieldIndex}
                style={{
                  minWidth:
                    field.width.value === "s"
                      ? "15%"
                      : field.width.value === "m"
                      ? "20%"
                      : "30%",
                }}
              >

                <label
                  className="form-label"
                  style={{ display: "block", fontSize: "12px", marginBottom: "4px" }}
                >
                  {field.renameValue || formatColumnName(field.columnName)}:
                </label>

                {field.function === "Input Field" ? (
                  <input
                    type={
                      field.type?.value === "decimal" || field.type?.value === "integer"
                        ? "number"
                        : "text"
                    }

                    name={field.columnName}
                    value={
  field.type?.value === "text"
    ? (row[field.columnName] || "")
    : row[field.columnName] !== undefined && row[field.columnName] !== null
      ? String(row[field.columnName])
      : ""
}


                    onChange={(e) =>
                      handleInputChange2(index, field.columnName, e.target.value, field.type)
                    }
                    className="form-control"
                  />
                ) : (
                  <div
                    className="form-control"
                    style={{ background: "#f5f5f5", minHeight: "30px" }}
                  >
                    {row[field.columnName] || 0.00}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

    </div>
  ))
) : (
  <p>No rows yet. Click + to add one.</p>
)}
</div>

          <div>
            <DynamicForm fields={fields3} formData={formData} onInputChange={handleInputChange} onSubmit={handleSubmit} />
          </div>

          <div>
            <DynamicForm fields={fields4} formData={formData} onInputChange={handleInputChange} onSubmit={handleSubmit} />
          </div>

<div style = {{display : "flex"}} >
      <div style={{ marginTop: '20px' }}>
        <button
          className="submit-btn"
          onClick={handleSubmit}
        >
          Save
        </button>
      </div>

      <div style={{ marginTop: '20px' }}>
        <button
          className="submit-btn"
          onClick={handleClick1}
        >
          Back
        </button>
      </div>
</div>


</div>
  </div>
</div>
</div>
</div>
</>
  );
}

export default PurchaseRequirement;